import { ref } from 'vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import GoodInfoFilterBlock from '@/views/goodsManage/goodsInfo/components/GoodInfoFilterBlock.vue';
import GoodInfoTableBlock from '@/views/goodsManage/goodsInfo/components/GoodInfoTableBlock.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    defineComponent({
      name: 'goodsInfo'
    });
    const tableRef = ref(null);
    const filterRef = ref(null);
    const router = useRouter();
    const filterSubmit = obj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(obj);
    };
    const emptyTable = () => {
      var _tableRef$value2;
      (_tableRef$value2 = tableRef.value) === null || _tableRef$value2 === void 0 || _tableRef$value2.emptyTable();
    };
    const goDetail = e => {
      var _filterRef$value, _filterRef$value2;
      router.push({
        name: 'goodsInfo',
        query: {
          dbtId: (_filterRef$value = filterRef.value) === null || _filterRef$value === void 0 ? void 0 : _filterRef$value.dbtId,
          prodChnl: (_filterRef$value2 = filterRef.value) === null || _filterRef$value2 === void 0 ? void 0 : _filterRef$value2.channel,
          type: 'watch',
          id: e
        }
      });
    }; // 跳转详情页
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(GoodInfoFilterBlock, {
        ref_key: "filterRef",
        ref: filterRef,
        onFilterSubmit: filterSubmit,
        onEmptyTable: emptyTable
      }, null, 512), _createVNode(GoodInfoTableBlock, {
        ref_key: "tableRef",
        ref: tableRef,
        onGoDetail: goDetail
      }, null, 512)]);
    };
  }
});